<template>
  <div class="mt-3 mx-3">
    <v-card class="pa-3 rounded-lg"
      :style="{ backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg-lhp)' : 'var(--light-bg-lhp)' }">
      <v-row>
        <v-col cols="12">
          <div class="pa-3">
            <span class="text-subtitle-2 font-weight-bold align-center">Grafik Bulanan</span>
          </div>
        </v-col>
      </v-row>
      <v-divider class="mx-3" />
      <div class="chart-container mx-3">
        <div class="chart-wrapper">
          <div v-if="loading" class="d-flex justify-center align-center" style="height: 300px;">
            <v-progress-circular indeterminate color="primary" size="40" />
          </div>
          <canvas v-else ref="chartBulananCanvas"></canvas>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Chart from "chart.js";
import services from "@/services";

export default {
  props: {
    chartType: {
      type: String,
      default: "bar",
    },
  },
  data() {
    return {
      loading: true,
      chartInstanceBulanan: null,
      chartDataBulanan: {
        labels: [],
        datasets: [
          {
            label: "Target",
            backgroundColor: "#e76f51",
            data: [],
          },
          {
            label: "Menagih",
            backgroundColor: "#520e63",
            data: [],
          },
          {
            label: "Tertagih",
            backgroundColor: "#27445D",
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                fontSize: 8,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 8,
                callback: function (value) {
                  return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0
                  }).format(value);
                },
              },
            },
          ],
        },
        tooltips: {
          bodyFontSize: 8,
          titleFontSize: 8,
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label || "";
              const value = tooltipItem.yLabel;
              const formatted = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0
              }).format(value);
              return `${label}: ${formatted}`;
            },
          },
        },
        legend: {
          labels: {
            fontSize: 8,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  async mounted() {
    await this.fetchChartDataBulanan();
  },
  methods: {
    async fetchChartDataBulanan() {
      this.loading = true;
      try {
        const payload = new FormData();
        payload.append("branch_code", this.user.branch_code);

        const response = await services.grafikBulanan(payload);

        if (response.data && response.data.status && response.data.data) {
          const { target = [], menagih = [], tertagih = [] } = response.data.data;
          const labels = target.map((item) => String(item.bulan));
          const targetValues = target.map((item) => Number(item.nominal) || 0);
          const menagihValues = menagih.map((item) => Number(item.nominal) || 0);
          const tertagihValues = tertagih.map((item) => Number(item.nominal) || 0);

          // Update chart data
          this.chartDataBulanan.labels = labels;
          this.chartDataBulanan.datasets[0].data = targetValues;
          this.chartDataBulanan.datasets[1].data = menagihValues;
          this.chartDataBulanan.datasets[2].data = tertagihValues;

          this.loading = false;

          this.$nextTick(() => {
            this.renderChartBulanan();
          });
        } else {
          console.error("Status API false atau format data tidak sesuai:", response.data);
          this.loading = false;
        }
      } catch (error) {
        console.error("Fetch chart error:", error);
        this.loading = false;
      }
    },
    renderChartBulanan() {
      if (this.chartInstanceBulanan) {
        this.chartInstanceBulanan.destroy();
      }

      const canvas = this.$refs.chartBulananCanvas;
      if (!canvas) {
        return;
      }

      const ctx = canvas.getContext("2d");

      this.chartInstanceBulanan = new Chart(ctx, {
        type: this.chartType,
        data: this.chartDataBulanan,
        options: this.chartOptions,
      });
    },
  },
  beforeDestroy() {
    if (this.chartInstanceBulanan) {
      this.chartInstanceBulanan.destroy();
    }
  },
};
</script>

<style scoped>
.chart-container {
  overflow-x: auto;
}

.chart-wrapper {
  min-width: 800px;
  height: 300px;
}
</style>
